import { extractMobileNumber } from '@back-office/ui';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import makeStyles from '@material-ui/core/styles/makeStyles';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

export const useStyles = makeStyles((theme) => ({
  tableHead: {
    border: '0.5px solid #F0F0F0',
    backgroundColor: '#FAFAFA',
  },
  tableCell: {
    border: '0.5px solid #F0F0F0',
  },
  header: {
    padding: '1rem',
  },
}));

type UserDetailProps = {
  walletId: string;
  fullName: string;
  mobileNo: string;
  createdBy: string;
};

const UserDetail: FC<UserDetailProps> = (props) => {
  const { walletId, fullName, mobileNo, createdBy } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Grid container>
      <Typography className={classes.header}>
        {t('recurring_payment_detail.user_details')}
      </Typography>
      <TableContainer>
        <Table aria-label="User Detail">
          <TableBody>
            <TableRow>
              <TableCell className={classes.tableHead} width="25%">
                <Typography>
                  {t('recurring_payment_detail.wallet_id')}
                </Typography>
              </TableCell>
              <TableCell className={classes.tableCell} colSpan={3} width="75%">
                <Typography> {walletId || '-'}</Typography>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableHead} width="25%">
                <Typography>
                  {t('recurring_payment_detail.full_name')}
                </Typography>
              </TableCell>
              <TableCell className={classes.tableCell} colSpan={3} width="75%">
                <Typography>{fullName || '-'}</Typography>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableHead} width="25%">
                <Typography>
                  {t('recurring_payment_detail.mobile_number')}
                </Typography>
              </TableCell>
              <TableCell className={classes.tableCell} width="25%">
                <Typography>{extractMobileNumber(mobileNo || '')}</Typography>
              </TableCell>
              <TableCell className={classes.tableHead} width="25%">
                <Typography>
                  {t('recurring_payment_detail.email_address')}
                </Typography>
              </TableCell>
              <TableCell className={classes.tableCell} width="25%">
                <Typography> {createdBy || '-'}</Typography>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Grid>
  );
};

export default UserDetail;
